{
  "version": 1,
  "asset_id": "7ab962b4-c682-44ac-ab42-a8ea3e73cce8",
  "project_id": "9fb22223-732b-4b0d-9eac-b115ce8cfd9c",
  "url": "/__l5e/assets-v1/7ab962b4-c682-44ac-ab42-a8ea3e73cce8/google.svg",
  "r2_key": "a/v1/9fb22223-732b-4b0d-9eac-b115ce8cfd9c/7ab962b4-c682-44ac-ab42-a8ea3e73cce8/google.svg",
  "original_filename": "google.svg",
  "size": 1906,
  "content_type": "image/svg+xml",
  "created_at": "2026-06-16T14:53:39Z"
}
